import ButtonToolbar from "@rio-cloud/rio-uikit/ButtonToolbar";
import Button from "@rio-cloud/rio-uikit/Button";

interface Props {
  label: string;
  onClick: () => void;
}

const ToolbarCreateButton = ({ label, onClick }: Props) => (
  <div className="table-toolbar-column table-toolbar-column-spacer">
    <ButtonToolbar className="display-grid grid-cols-1 display-flex-ls">
      <Button
        bsStyle={Button.PRIMARY}
        iconName="rioglyph-plus"
        className="rounded-small width-100pct-xs width-150"
        onClick={onClick}
      >
        {label}
      </Button>
    </ButtonToolbar>
  </div>
);

export default ToolbarCreateButton;
